import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Link, Route, Switch, useLocation } from 'react-router-dom';
import NewBitwerxOfferingModal from './NewBitwerxOfferingModal';
import NewButton from '../Shared/NewButton';
import BitwerxOffering from './BitwerxOffering';
import React, { useCallback, useEffect, useState } from 'react';
import { Facebook } from 'react-spinners-css';
import { actions } from '../../../context';
import { Col, Container, ListGroup, ListGroupItem, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { faLaptop } from '@fortawesome/free-solid-svg-icons';
import hasPermission from '../../Shared/hasPermission';

const BitwerxOfferings = () => {
    const loc = useLocation();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [bitwerxOfferings, setBitwerxOfferings] = useState([]);
    const [newBitwerxOffering, setNewBitwerxOffering] = useState(false);
    const toggleNew = useCallback(() => setNewBitwerxOffering(!newBitwerxOffering), [newBitwerxOffering]);

    const { permissions } = useSelector((state) => ({
        permissions: state.auth.permissions,
    }), shallowEqual);

    const refresh = useCallback(async () => {
        setLoading(true);
        return await dispatch(actions.offerings.fetchBitwerxOfferings())
            .then((res) => {
                setBitwerxOfferings(res || []);
            })
            .then(() => setLoading(false));
    }, [dispatch]);

    useEffect(() => {
        refresh();
        // eslint-disable-next-line
    }, [dispatch]);

    return (
        <>
            {hasPermission('ModifyBitwerxOfferings', permissions) && (
                <NewBitwerxOfferingModal
                    isOpen={newBitwerxOffering}
                    toggle={toggleNew}
                    refresh={refresh}
                />
            )}
            <Container>
                <Row className="text-white">
                    <Col lg="3">
                        <div className="d-flex justify-content-between">
                            <h2>
                                <FontAwesomeIcon icon={faLaptop} />
                                &emsp;Bitwerx Offerings
                            </h2>
                            <div>
                                {hasPermission('ModifyBitwerxOfferings', permissions) && (
                                    <NewButton
                                        noSpaces
                                        id="newBitwerxOffering"
                                        title="Create new Bitwerx Offering"
                                        onClick={toggleNew}
                                    />
                                )}
                            </div>
                        </div>
                        {loading ? (
                            <h2 className="m-4 text-center">
                                <Facebook color="#eee" />
                            </h2>
                        ) : (
                            <ListGroup
                                style={{
                                    maxHeight: '80vh',
                                    overflowY: 'scroll',
                                }}>
                                {bitwerxOfferings.map((offering) => (
                                    <div
                                        key={offering.id}
                                        className={classNames({
                                            'text-dark': !loc.pathname.includes(
                                                offering.id
                                            ),
                                        })}>
                                        <Link
                                            to={`/admin/bitwerxofferings/${offering.id}`}
                                            style={{ textDecoration: 'none' }}>
                                            <ListGroupItem
                                                action
                                                active={loc.pathname.includes(
                                                    offering.id
                                                )}>
                                                <div>{offering.name}</div>
                                            </ListGroupItem>
                                        </Link>
                                    </div>
                                ))}
                            </ListGroup>
                        )}
                    </Col>
                    <Col lg="9">
                        <Switch>
                            <Route path="/admin/bitwerxofferings/:bitwerxofferingId">
                                <BitwerxOffering
                                    refreshBitwerxOfferings={refresh}
                                />
                            </Route>
                        </Switch>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default React.memo(BitwerxOfferings);
